import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-h3 text-grey-9" }, "Please Login", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle2" }, "To Access the Control Center", -1 /* HOISTED */)
const _hoisted_4 = { class: "text-h6" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Logout ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Go to Dashboard ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { padding: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_card, {
          style: {"width":"360px"},
          bordered: ""
        }, {
          default: _withCtx(() => [
            (!_ctx.isLoggedIn)
              ? (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 0,
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _hoisted_3,
                    _createVNode(_component_q_icon, {
                      name: "mdi-account-circle-outline",
                      class: "text-grey-5",
                      size: "16em"
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (_ctx.isLoggedIn)
              ? (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 1,
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.user.email), 1 /* TEXT */),
                    _createCommentVNode("          <div class=\"text-subtitle2\">"),
                    _createCommentVNode("            {{ user.username }}"),
                    _createCommentVNode("          </div>"),
                    _createVNode(_component_q_icon, {
                      name: "mdi-account-circle",
                      class: "text-grey-5",
                      size: "16em"
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_q_separator),
            (!_ctx.isLoggedIn)
              ? (_openBlock(), _createBlock(_component_q_card_actions, {
                  key: 2,
                  class: "justify-center"
                }, {
                  default: _withCtx(() => [
                    _createCommentVNode("          <q-btn"),
                    _createCommentVNode("            flat"),
                    _createCommentVNode("            type=\"a\""),
                    _createCommentVNode("            :href=\"cognitoUrl\""),
                    _createCommentVNode("            label=\"Cognito\""),
                    _createCommentVNode("            color=\"secondary\""),
                    _createCommentVNode("          />"),
                    _createCommentVNode("                    <q-space />"),
                    _createVNode(_component_q_btn, {
                      type: "a",
                      href: _ctx.azureUrl,
                      label: "Login",
                      color: "primary",
                      class: "full-width",
                      padding: "sm"
                    }, null, 8 /* PROPS */, ["href"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (_ctx.isLoggedIn)
              ? (_openBlock(), _createBlock(_component_q_card_actions, { key: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      type: "a",
                      to: { name: 'logout' },
                      flat: "",
                      class: "text-grey-7"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_btn, {
                      type: "a",
                      to: { name: 'dashboard' },
                      class: "bg-primary text-white"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }))
}